"use client";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ContactForm } from "@/components/contact-form";

/**
 * Pop-up-Praesentation des Kontaktformulars (backlog.md -> Feedback-Runde 19 Punkt 42:
 * "Kontaktformular als Pop-up neben der E-Mail-Adresse"), z.B. im Impressum direkt neben
 * der E-Mail platziert. Gleiche Formularlogik wie /kontakt, nur anders eingebettet.
 */
export function ContactFormDialog({ trigger }: { trigger?: React.ReactNode }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {trigger ?? (
          <Button variant="outline" size="sm">
            Kontaktformular öffnen
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-serif text-xl">Schreib uns</DialogTitle>
          <DialogDescription>
            Zweiter Kontaktweg neben der E-Mail-Adresse — wir antworten direkt auf die von
            dir angegebene Adresse.
          </DialogDescription>
        </DialogHeader>
        <ContactForm />
      </DialogContent>
    </Dialog>
  );
}
